module.exports = __webpack_public_path__ + "static/media/9.990e8fc6.jpg";